var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-3" }, [
    _c(
      "table",
      { staticClass: "table tablerow", attrs: { id: _vm.$attrs.id } },
      [
        _c(
          "caption",
          [
            _c("plain-text-control", {
              attrs: {
                title: _vm.$attrs.titleKey,
                required: _vm.$attrs.required
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", [
              _c("span", { attrs: { id: _vm.$attrs.id + "description" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidTargetYearlyReport.GeneralExpenses.Breakdown.Description"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("th", [
              _c(
                "span",
                { attrs: { id: _vm.$attrs.id + "distributionReason" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AidTargetYearlyReport.GeneralExpenses.Breakdown.DistributionReason"
                      )
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "w-30" }, [
              _c(
                "span",
                {
                  staticClass: "right",
                  attrs: { id: _vm.$attrs.id + "aidTargetedSum" }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "AidTargetYearlyReport.GeneralExpenses.Breakdown.AidTargetedSum"
                      )
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showActions
              ? _c("th", { staticClass: "w-5" }, [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Accessibility.Action")))
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.expenseItems, function(expense, index) {
            return _c(
              "tr",
              {
                key: _vm.$attrs.id + "-" + index,
                attrs: { id: _vm.$attrs.id + "-" + index }
              },
              [
                _c(
                  "td",
                  { staticClass: "input-cell row-heading" },
                  [
                    _c("text-area-control", {
                      attrs: {
                        id: "generalExpenseDescription_" + index,
                        labelledBy: _vm.$attrs.id + "description",
                        rows: 1,
                        maxLength: 50,
                        required: _vm.getRequired(expense),
                        disabled: _vm.isReadOnly,
                        placeholderKey: _vm.textAreaPlaceholderKey
                      },
                      model: {
                        value: expense.description,
                        callback: function($$v) {
                          _vm.$set(expense, "description", $$v)
                        },
                        expression: "expense.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("text-area-control", {
                      attrs: {
                        id: "distributionReason_" + index,
                        labelledBy: _vm.$attrs.id + "distributionReason",
                        rows: 1,
                        maxLength: 50,
                        required: _vm.getRequired(expense),
                        disabled: _vm.isReadOnly,
                        placeholderKey: _vm.textAreaPlaceholderKey
                      },
                      model: {
                        value: expense.distributionReason,
                        callback: function($$v) {
                          _vm.$set(expense, "distributionReason", $$v)
                        },
                        expression: "expense.distributionReason"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        required: _vm.getRequired(expense),
                        disabled: _vm.isReadOnly,
                        placeholderKey: _vm.numberInputPlaceholderKey,
                        labelledBy: _vm.$attrs.id + "aidTargetedSum"
                      },
                      model: {
                        value: expense.aidTargetedSum,
                        callback: function($$v) {
                          _vm.$set(expense, "aidTargetedSum", $$v)
                        },
                        expression: "expense.aidTargetedSum"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showActions
                  ? _c("td", [
                      _c("span", { staticClass: "centered" }, [
                        _vm.canDelete && !_vm.isReadOnly
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-link btn-contrast",
                                attrs: {
                                  type: "button",
                                  "aria-label":
                                    _vm.$t("Btn_DeleteRow") +
                                    (index + 2) +
                                    " -. " +
                                    _vm.$t("Accessibility.ConfirmDeleteRow")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeLineItem(expense)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-trash-alt fa-lg centered"
                                })
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    !_vm.isReadOnly
      ? _c("div", { staticClass: "mt-3" }, [
          _vm.enableAddButton
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top.center",
                      value: _vm.getAddButtonTooltip(),
                      expression: "getAddButtonTooltip()",
                      modifiers: { top: true, center: true }
                    }
                  ],
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.addExpenseItem }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t(_vm.addButtonKey)) + "\n      "
                  ),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.$attrs.addButtonTooltip)))
                  ])
                ]
              )
            : _vm.showActions
            ? _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: {
                    type: "button",
                    disabled: "",
                    "aria-disabled": "true"
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t(_vm.addButtonKey)) + "\n    "
                  )
                ]
              )
            : _vm._e()
        ])
      : _c("div", { staticClass: "mb-5" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }